import { render, staticRenderFns } from "./EmployeeTaskHistoryPanel.vue?vue&type=template&id=1cfef7ba&"
import script from "./EmployeeTaskHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./EmployeeTaskHistoryPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports